import React from 'react';

const TowerIcon = (props) => {
  return (
    <img
      alt="Wieża widokowa"
      src="/static/images/icons/tourist_attractions/tower.svg"
      {...props}
    />
  );
};

export default TowerIcon;
